"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const appStateCreateStore_1 = __importDefault(require("./appStateCreateStore"));
const AppStateConstants_1 = require("../types/AppStateConstants");
const appStateBuildGetStoreHook = ({ getInitialBO, subscribeToBORequestRestart, onStoreCreated, functions, interfaces, }) => (hookArgs) => {
    const [store, setStore] = (0, react_1.useState)(undefined);
    (0, react_1.useEffect)(() => {
        getInitialBO({
            appId: hookArgs.appId,
            projectId: hookArgs.projectId,
        }).then((buildOrders) => (0, appStateCreateStore_1.default)({
            appId: hookArgs.appId,
            projectId: hookArgs.projectId,
            buildOrders,
            functions: {
                areEnabled: functions.areEnabled,
                definitions: functions.definitions,
            },
            localStorage: interfaces.localStorage,
        })).then(setStore);
    }, [
        hookArgs.appId,
        hookArgs.projectId,
    ]);
    (0, react_1.useEffect)(() => {
        if (!store || !onStoreCreated) {
            return undefined;
        }
        return onStoreCreated(store);
    }, [store]);
    (0, react_1.useEffect)(() => {
        if (!subscribeToBORequestRestart) {
            return undefined;
        }
        return subscribeToBORequestRestart({
            appId: hookArgs.appId,
            projectId: hookArgs.projectId,
            listener: () => {
                if (!store) {
                    return;
                }
                store.dispatch({
                    type: AppStateConstants_1.AppStateConstants.BO_REQUEST_RESET,
                });
            },
        });
    }, [hookArgs.appId, hookArgs.projectId, store]);
    return store;
};
exports.default = appStateBuildGetStoreHook;
